import { WebhookConfig, WebhookSettings } from '../types';

class WebhookConfigManager {
  private config: WebhookSettings = {
    contactWebhookUrl: '',
    analyticsWebhookUrl: '',
    batchWebhookUrl: '',
    retryAttempts: 3,
    retryDelay: 1000,
    timeout: 10000,
  };

  constructor() {
    this.loadFromStorage();
  }

  // 설정 업데이트
  updateSettings(newConfig: Partial<WebhookConfig>): void {
    this.config = { ...this.config, ...newConfig };
    this.saveToStorage();
  }

  // 설정 가져오기
  getSettings(): WebhookSettings {
    return { ...this.config };
  }

  // 특정 웹훅 URL 가져오기
  getWebhookUrl(type: 'contact' | 'analytics' | 'batch'): string {
    switch (type) {
      case 'contact':
        return this.config.contactWebhookUrl;
      case 'analytics':
        return this.config.analyticsWebhookUrl;
      case 'batch':
        return this.config.batchWebhookUrl;
      default:
        return '';
    }
  }

  // 설정 초기화
  reset(): void {
    this.config = {
      contactWebhookUrl: '',
      analyticsWebhookUrl: '',
      batchWebhookUrl: '',
      retryAttempts: 3,
      retryDelay: 1000,
      timeout: 10000,
    };
    this.saveToStorage();
  }

  // 로컬 스토리지에서 설정 로드
  private loadFromStorage(): void {
    if (typeof window !== 'undefined') {
      try {
        const stored = localStorage.getItem('webhook-config');
        if (stored) {
          const parsed = JSON.parse(stored);
          this.config = { ...this.config, ...parsed };
        }
      } catch (error) {
        console.warn('웹훅 설정 로드 실패:', error);
      }
    }
  }

  // 로컬 스토리지에 설정 저장
  private saveToStorage(): void {
    if (typeof window !== 'undefined') {
      try {
        localStorage.setItem('webhook-config', JSON.stringify(this.config));
      } catch (error) {
        console.warn('웹훅 설정 저장 실패:', error);
      }
    }
  }

  // 설정 유효성 검사
  isValid(): boolean {
    return !!(this.config.contactWebhookUrl || 
              this.config.analyticsWebhookUrl || 
              this.config.batchWebhookUrl);
  }

  // 특정 타입의 웹훅 URL이 설정되어 있는지 확인
  hasWebhookUrl(type: 'contact' | 'analytics' | 'batch'): boolean {
    return !!this.getWebhookUrl(type);
  }
}

// 싱글톤 인스턴스 생성
export const webhookConfig = new WebhookConfigManager(); 